import { render, staticRenderFns } from "./ClientInvoiceSummary.vue?vue&type=template&id=18c985b3&"
import script from "./ClientInvoiceSummary.vue?vue&type=script&lang=js&"
export * from "./ClientInvoiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoiceSummary.vue?vue&type=style&index=0&id=18c985b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports